import { RouteRecordRaw } from 'vue-router';

const importedEmploymentRoutes: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'ImportedEmploymentsOverview',
      component: () => import('@/modules/imported-employments/pages/ImportedEmploymentsOverview.vue'),
   },
   {
      path: ':id',
      name: 'ImportedEmploymentsDetails',
      component: () => import('@/modules/imported-employments/pages/ImportedEmploymentsDetails.vue'),
   },
];

export default importedEmploymentRoutes;
